export default __webpack_public_path__ + "0c94bc025f022b95800f045153a2b876.svg";